function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { border, height, maxHeight, maxWidth, minHeight, width } from 'styled-system';
import Flex from '../Flex';
import SpreadsheetFooter from './SpreadsheetFooter';
import SpreadsheetGrid from './SpreadsheetGrid';
import SpreadsheetHeader from './SpreadsheetHeader';
import { SpreadsheetContext } from './SpreadsheetManager';
const StyledSpreadsheet = styled(Flex).withConfig({
  displayName: "Spreadsheet__StyledSpreadsheet",
  componentId: "sc-152cthx-0"
})(["", " ", " ", " ", " ", " ", " ", ""], border, height, maxHeight, maxWidth, minHeight, width, props => props.maximize && "\n    width: 100vw;\n    height: 100vh;\n    max-height: 100vh;\n    top: 0;\n    left: 0;\n    z-index: 1000;\n  ");
const Spreadsheet = /*#__PURE__*/React.memo(_ref => {
  let {
    heightAdjustment,
    ...props
  } = _ref;
  const containerRef = React.useRef();
  const [inDom, setInDom] = React.useState(false);
  const ctx = React.useContext(SpreadsheetContext);
  React.useEffect(() => {
    containerRef.current = document.createElement('div');
    document.body.appendChild(containerRef.current);
    setInDom(true);
    return () => {
      document.body.removeChild(containerRef.current);
    };
  }, []);
  const width = React.useMemo(() => {
    return ctx.headerCells.reduce((sum, _ref2) => {
      let {
        width
      } = _ref2;
      return sum + width;
    }, 0);
  }, [ctx.headerCells]);
  const content = /*#__PURE__*/React.createElement(StyledSpreadsheet, _extends({}, props, {
    height: ctx.rows.length * 40 + 120 + 18 + heightAdjustment,
    width: width + 2,
    maximize: ctx.maximize,
    style: {
      position: ctx.maximize ? 'fixed' : 'relative'
    },
    flexDirection: "column"
  }), /*#__PURE__*/React.createElement(SpreadsheetHeader, {
    borderRadius: ctx.maximize ? 0 : 'corner',
    onMaximizeSize: ctx.maximize ? null : ctx.onMaximizeSize,
    onRestoreSize: ctx.maximize ? ctx.onRestoreSize : null
  }), !!props.afterHeader && props.afterHeader, /*#__PURE__*/React.createElement(SpreadsheetGrid, {
    cellRenderer: props.cellRenderer,
    headerCells: ctx.headerCells,
    rows: ctx.rows
  }), /*#__PURE__*/React.createElement(SpreadsheetFooter, null));
  return ctx.maximize && inDom ? /*#__PURE__*/ReactDOM.createPortal(content, containerRef.current) : content;
});
Spreadsheet.propTypes = {
  ...Flex.propTypes,
  ...border.propTypes,
  ...height.propTypes,
  ...maxHeight.propTypes,
  ...maxWidth.propTypes,
  ...minHeight.propTypes,
  ...width.propTypes,
  cellRenderer: PropTypes.func.isRequired,
  afterHeader: PropTypes.node
};
Spreadsheet.defaultProps = {
  border: 'default',
  heightAdjustment: 0,
  maxHeight: '70vh',
  maxWidth: '100%',
  minHeight: '160px'
};
Spreadsheet.displayName = 'Spreadsheet';
export default Spreadsheet;